import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad8.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[10];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[11].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[11].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[9].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[9].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>Trabaja con un compañero, compañera o familiar. </li>
            <li>
              Piensen en dos situaciones en que ser bilingües podría ser de
              mucha ayuda para mejorar nuestra convivencia. Por ejemplo: “Ha
              habido un robo en el mercado. La dueña del puesto donde han robado
              habla quechua y muy poco castellano. Por suerte, llega un policía
              que también habla quechua y entonces puede informarse muy bien de
              lo que ha pasado y ayudar a la vendedora”.
            </li>
          </ul>
          <div className="row align-items-center my-5 px-4">
            <div className="col-lg-10 col-12">
              <label>Situación 1</label>
              <textarea className="form-control w-100" rows="8" />
            </div>
            <div className="col-lg-10 col-12 mt-4">
              <label>Situación 2</label>
              <textarea className="form-control w-100" rows="8" />
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Ahora crearás en una hoja un dibujo que incentive a los peruanos a
              mantener vivas las lenguas originarias de nuestro país.
            </li>
            <li>
              Acompaña el dibujo de una frase. Puedes utilizar algunas de estas
              palabras.
            </li>
          </ul>
          <div className="row align-items-center my-5 px-4">
            <div className="col-lg-10 col-12">
              <div className="border border-2 rounded shadow p-4 mb-5">
                <div className="d-flex justify-content-center align-items-center">
                  <div className="px-2">lenguas</div>
                  <div className="px-2">diversidad</div>
                  <div className="px-2">Perú</div>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="px-2">comunicación</div>
                  <div className="px-2">educación </div>
                  <div className="px-2">multilingüe</div>
                  <div className="px-2">convivir</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique que estas actividades tienen como
            objetivo incentivar el respeto y la protección de las lenguas
            originarias. Para ello, se busca que los y las estudiantes tomen
            conciencia de que el reconocimiento y promoción de la diversidad
            lingüística de nuestro país son necesarios para la convivencia entre
            peruanos.
          </li>
          <li>
            Lea las
            dos primeras indicaciones: Trabaja con dos compañeros, compañeras o un familiar.
            Piensen en dos situaciones en que ser bilingües podría ser de mucha
            ayuda para mejorar nuestra convivencia. Por ejemplo: “Ha habido un
            robo en el mercado. La dueña del puesto donde han robado habla
            quechua y muy poco castellano. Por suerte, llega un policía que
            también habla quechua y entonces puede informarse muy bien de lo que
            ha pasado y ayudar a la vendedora”. Para realizar la actividad, pida
             que primero conversen y se pongan de acuerdo sobre
            las situaciones que describirán. No deben perder de vista que se
            trata de describir una situación en la que el bilingüismo colabore a
            resolver un problema, tal y como se ejemplifica en la situación del
            mercado. Mientras trabajan, acérquese a sus carpetas
            para escuchar los ejemplos que se les ocurren y orientarlos. Luego,
            una vez que hayan escrito los ejemplos, revise la coherencia del
            texto escrito. Pida que lean sus ejemplos.
            Pregunte para cada uno de ellos:
            <ul>
              <li>
                <i>
                  “¿Por qué creen que en este ejemplo colaboró el bilingüismo a
                  la convivencia?
                </i>
              </li>
              <li>
                <i>
                  ¿Qué hubiese pasado si en la situación descrita nadie era
                  bilingüe?”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea las dos indicaciones: Ahora crearás un dibujo que incentive a
            los peruanos a mantener vivas las lenguas originarias de nuestro
            país. Acompaña el dibujo de una frase. Puedes utilizar algunas de
            estas palabras: lenguas, diversidad, Perú, comunicación, educación,
            multilingüe, convivir. Asegúrese de que comprenden
            el significado de todas las palabras. Explique que
            los dibujos, son una manera de difundir determinadas ideas o
            información. La actividad busca que niños y niñas elaboren una frase
            motivadora para mantener vivas las lenguas originarias y que la
            acompañen de un dibujo que se relacione con la frase. Mientras dibujan, acérquese a sus carpetas y revise la coherencia
            de la frase que escribirán y la pertinencia del dibujo.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
